import Cookies from 'js-cookie';
import axios from 'axios';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var _a;
var API_ACCESS_TOKEN = 'api-access-token';
var axiosInstance = axios.create({
    baseURL: (_a = process.env.NEXT_PUBLIC_API_ENDPOINT) !== null && _a !== void 0 ? _a : process.env.API_V3_URL,
    withCredentials: true,
});
function onRequestFulfilled(config) {
    if (!config.baseURL) {
        console.warn('shared axios 인스턴스를 사용하기 위해 baseURL 환경변수가 필요합니다. (nextjs: NEXT_PUBLIC_API_ENDPOINT / 기타: API_V3_URL)');
        return config;
    }
    var token = Cookies.get(API_ACCESS_TOKEN);
    if (token && config.headers) {
        config.headers[API_ACCESS_TOKEN] = token;
    }
    return config;
}
function onResponseFulfilled(response) {
    var result = response.data.result;
    if (result.status >= 400) {
        return Promise.reject(result); // TODO: MrtAxiosException으로 대체
    }
    return Promise.resolve(response);
}
axiosInstance.interceptors.request.use(onRequestFulfilled);
axiosInstance.interceptors.response.use(onResponseFulfilled);

function withoutPayload(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, response, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = config.method, method = _a === void 0 ? 'get' : _a;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosInstance[method](url, config)];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response.data.data];
                case 3:
                    err_1 = _b.sent();
                    return [2 /*return*/, Promise.reject(err_1)]; // TODO: MrtException으로 대체
                case 4: return [2 /*return*/];
            }
        });
    });
}
function withPayload(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, method, response, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = config.method, method = _a === void 0 ? 'post' : _a;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosInstance[method](url, payload, config)];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response.data.data];
                case 3:
                    err_2 = _b.sent();
                    return [2 /*return*/, Promise.reject(err_2)]; // TODO: MrtException으로 대체
                case 4: return [2 /*return*/];
            }
        });
    });
}

function axiosGet(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withoutPayload(url, __assign(__assign({}, config), { method: 'get' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosDelete(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withoutPayload(url, __assign(__assign({}, config), { method: 'delete' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosHead(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withoutPayload(url, __assign(__assign({}, config), { method: 'head' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosOptions(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withoutPayload(url, __assign(__assign({}, config), { method: 'options' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPost(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'post' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPut(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'put' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPatch(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'patch' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPostForm(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'postForm' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPutForm(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'putForm' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function axiosPatchForm(url, payload, config) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, withPayload(url, payload, __assign(__assign({}, config), { method: 'patchForm' }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}

function fetchTyped(url, config) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, config)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}

export { axiosDelete, axiosGet, axiosHead, axiosInstance, axiosOptions, axiosPatch, axiosPatchForm, axiosPost, axiosPostForm, axiosPut, axiosPutForm, fetchTyped };
